var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimelineManualicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "basil:gamepad-solid",
    clipPath: "url(#clip0_4189_1290)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_dd_4189_1290)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4198 2.00439C11.5932 2.00439 11.7596 2.07329 11.8822 2.19592C12.0048 2.31855 12.0737 2.48488 12.0737 2.65831C12.0737 3.49813 12.7485 4.17953 13.5875 4.21764C14.3302 4.25138 15.0726 4.30251 15.8141 4.37157L16.1018 4.39772C17.0556 4.48606 17.9431 4.92328 18.5944 5.62558C19.2457 6.32787 19.6149 7.24583 19.6312 8.2035L19.6417 8.82516C19.6827 11.2448 19.4876 13.6626 19.0593 16.0444C18.9647 16.5693 18.6886 17.0444 18.2794 17.3865C17.8701 17.7287 17.3537 17.9162 16.8203 17.9163H16.6276C16.1426 17.9163 15.668 17.7755 15.2614 17.511C14.8548 17.2465 14.5338 16.8697 14.3371 16.4263L13.4129 14.3425C12.6457 12.6135 10.1939 12.6135 9.42756 14.3425L8.50336 16.4263C8.30662 16.8699 7.98529 17.2469 7.57837 17.5114C7.17146 17.7759 6.6965 17.9166 6.21117 17.9163H6.01935C5.4855 17.9166 4.96856 17.7291 4.55894 17.3868C4.14932 17.0444 3.8731 16.5689 3.77861 16.0435C3.35059 13.662 3.15582 11.2445 3.19706 8.82516L3.20752 8.2035C3.22386 7.2457 3.59317 6.32762 4.24464 5.62531C4.89612 4.92299 5.7839 4.48586 6.73779 4.39772L7.02725 4.37157C7.76795 4.30291 8.51008 4.25162 9.25304 4.21773C10.0919 4.17946 10.7668 3.49808 10.7668 2.65831C10.7668 2.48488 10.8357 2.31855 10.9583 2.19592C11.0809 2.07329 11.2473 2.00439 11.4207 2.00439H11.4198ZM15.7792 7.01774C15.7792 6.7865 15.6874 6.56473 15.5239 6.40122C15.3604 6.23771 15.1386 6.14585 14.9074 6.14585C14.6761 6.14585 14.4544 6.23771 14.2908 6.40122C14.1273 6.56473 14.0355 6.7865 14.0355 7.01774V7.23571C14.0355 7.46695 14.1273 7.68872 14.2908 7.85223C14.4544 8.01574 14.6761 8.1076 14.9074 8.1076C15.1386 8.1076 15.3604 8.01574 15.5239 7.85223C15.6874 7.68872 15.7792 7.46695 15.7792 7.23571V7.01774ZM7.93227 6.36383C8.1057 6.36383 8.27203 6.43272 8.39466 6.55535C8.51729 6.67799 8.58619 6.84431 8.58619 7.01774C8.58619 7.61965 9.07413 8.1076 9.67604 8.1076C9.84947 8.1076 10.0158 8.17649 10.1384 8.29912C10.2611 8.42176 10.33 8.58808 10.33 8.76151C10.33 8.93494 10.2611 9.10127 10.1384 9.2239C10.0158 9.34653 9.84947 9.41543 9.67604 9.41543C9.07413 9.41543 8.58619 9.90337 8.58619 10.5053C8.58619 10.6787 8.51729 10.845 8.39466 10.9677C8.27203 11.0903 8.1057 11.1592 7.93227 11.1592C7.75884 11.1592 7.59252 11.0903 7.46988 10.9677C7.34725 10.845 7.27836 10.6787 7.27836 10.5053C7.27836 9.90337 6.79041 9.41543 6.1885 9.41543C6.01507 9.41543 5.84874 9.34653 5.72611 9.2239C5.60348 9.10127 5.53458 8.93494 5.53458 8.76151C5.53458 8.58808 5.60348 8.42176 5.72611 8.29912C5.84874 8.17649 6.01507 8.1076 6.1885 8.1076C6.79041 8.1076 7.27836 7.61965 7.27836 7.01774C7.27836 6.84431 7.34725 6.67799 7.46988 6.55535C7.59252 6.43272 7.75884 6.36383 7.93227 6.36383ZM14.9074 9.41543C15.1386 9.41543 15.3604 9.50729 15.5239 9.6708C15.6874 9.83431 15.7792 10.0561 15.7792 10.2873V10.5053C15.7792 10.7365 15.6874 10.9583 15.5239 11.1218C15.3604 11.2853 15.1386 11.3772 14.9074 11.3772C14.6761 11.3772 14.4544 11.2853 14.2908 11.1218C14.1273 10.9583 14.0355 10.7365 14.0355 10.5053V10.2873C14.0355 10.0561 14.1273 9.83431 14.2908 9.6708C14.4544 9.50729 14.6761 9.41543 14.9074 9.41543ZM16.6511 9.6334C16.8824 9.6334 17.1041 9.54154 17.2676 9.37803C17.4312 9.21452 17.523 8.99275 17.523 8.76151C17.523 8.53027 17.4312 8.30851 17.2676 8.145C17.1041 7.98149 16.8824 7.88963 16.6511 7.88963H16.4332C16.2019 7.88963 15.9802 7.98149 15.8166 8.145C15.6531 8.30851 15.5613 8.53027 15.5613 8.76151C15.5613 8.99275 15.6531 9.21452 15.8166 9.37803C15.9802 9.54154 16.2019 9.6334 16.4332 9.6334H16.6511ZM14.2534 8.76151C14.2534 8.99275 14.1616 9.21452 13.9981 9.37803C13.8346 9.54154 13.6128 9.6334 13.3816 9.6334H13.1636C12.9323 9.6334 12.7106 9.54154 12.5471 9.37803C12.3836 9.21452 12.2917 8.99275 12.2917 8.76151C12.2917 8.53027 12.3836 8.30851 12.5471 8.145C12.7106 7.98149 12.9323 7.88963 13.1636 7.88963H13.3816C13.6128 7.88963 13.8346 7.98149 13.9981 8.145C14.1616 8.30851 14.2534 8.53027 14.2534 8.76151Z",
    fill: "url(#paint0_linear_4189_1290)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_4189_1290",
    x: -1.16778,
    y: 1.13251,
    width: 25.1742,
    height: 24.6307,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.871886,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_4189_1290"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.48754
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.61566
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4189_1290"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.871886,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_4189_1290"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.74377
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.74377
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4189_1290",
    result: "effect2_dropShadow_4189_1290"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4189_1290",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4189_1290",
    x1: -5.03605,
    y1: 9.96036,
    x2: 10.8669,
    y2: 26.4065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21D4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2152FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4189_1290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.9253,
    height: 20.9253,
    fill: "white",
    transform: "translate(0.957275 0.0427246)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineManualicon);
export default __webpack_public_path__ + "static/media/timeline-manualicon.c456419f39a5f92552265b97eec319c8.svg";
export { ForwardRef as ReactComponent };